var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObCallIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#OBCallIndicator_svg__clip0_8255_40917)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.499 1.733a.667.667 0 01.707.397L7.54 5.246a.667.667 0 01-.141.734l-.96.96A4.964 4.964 0 009.056 9.56l.96-.96a.667.667 0 01.735-.142l3.116 1.335c.277.119.44.409.397.707l-.42 2.94a.667.667 0 01-.629.571c-2.911.135-5.87-.91-8.094-3.133a10.713 10.713 0 01-3.134-8.095.667.667 0 01.572-.63l2.939-.42zM3.31 3.393a9.373 9.373 0 002.754 6.54 9.373 9.373 0 006.542 2.755l.267-1.871-2.231-.957-.946.946a.667.667 0 01-.682.161A6.297 6.297 0 015.03 6.984a.667.667 0 01.161-.682l.946-.946-.957-2.23-1.87.266z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "OBCallIndicator_svg__clip0_8255_40917"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.333 1.333)",
    d: "M0 0h13.333v13.333H0z"
  })))));
}

export default SvgObCallIndicator;